import React from 'react'
import { PromptSuccessIcon } from '../../assets/icons'
import { SuccessFailurePrompt } from '../molecules/SuccessFailurePrompt'
import { Text } from 'react-native'
import { useInvoiceDetailsContext } from '../../screens/Contractor/TabInvoice/InvoiceDetailsContext'

export const ConnectCardSuccess = ({ visible }) => {
  const { setCardSuccess } = useInvoiceDetailsContext()
  const onClose = () => {
    setCardSuccess(false)
  }
  return (
    <SuccessFailurePrompt
      visible={visible}
      exitable={false}
      onDismiss={onClose}
      contentContainerStyle={{ marginHorizontal: 40 }}
      title='Card linked'
      textContentBottomMargin={33}
      icon={<PromptSuccessIcon />}
      message={<Text>Your card has successfully linked to your BlueTape account.</Text>}
      buttonData={{ title: 'Done', onPress: onClose, style: { width: 150 } }}
    />
  )
}
